const transformDeltaToKey = (delta) => {
    if (delta < 0) {
        return 'down'
    }

    if (delta > 0) {
        return 'up'
    }

    return 'stay'
}

// eslint-disable-next-line import/prefer-default-export
export { transformDeltaToKey }
